import { useState } from 'react';
import userManager from '@/auth/authService';
import { useAuth } from '@/auth/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { createFileRoute } from '@tanstack/react-router'
import { KeyRound } from 'lucide-react';

export const Route = createFileRoute('/auth/login')({
  component: RouteComponent,
})

function RouteComponent() {
  const auth = useAuth();
  const [apiKeyDialogOpen, setApiKeyDialogOpen] = useState(false);
  const [apiKeyInput, setApiKeyInput] = useState('');

  const handleLogin = async () => {
    // Redirects user to OIDC provider's login page

    try {

      await userManager.signinRedirect();
    } catch (error) {
      console.error('Login failed:', error);
      // Handle error (e.g., show notification)
    }
  };

  const handleApiKeyLogin = () => {
    if (!apiKeyInput.trim()) return;
    auth?.loginWithApiKey(apiKeyInput.trim());
    setApiKeyDialogOpen(false);
    window.location.replace('/');
  };

  return (
    <div className="flex flex-col h-screen items-center justify-center bg-gray-100 gap-2">
      <Card className="my-10 w-96">
        <CardContent>

          <div className="flex flex-col gap-5 ">

            <div className="flex flex-col justify-center items-center">
              <div className="flex items-center bg-black p-2 rounded-md">
                <img
                  className="w-auto h-5"
                  src="../EssilorLuxotticaWhite.svg" // Replace with your logo path
                  alt="App Logo"
                  width={120} // Adjust size as needed
                  height={60} // Adjust size as needed
                />
              </div>
              <div className="text-normal font-Avenir text-black flex items-center">
                <span className="inline-flex mr-3">
                  <span className="h-3 w-3 bg-black rounded-full"></span>
                  <span className="h-3 w-3 bg-black rounded-full ml-1"></span>
                </span>
                MONTHLY CLOSING
              </div>

            </div>
            <div className="flex flex-col gap-3 items-center">
              <h1 className="text-4xl font-bold">Login</h1>
              <Button onClick={handleLogin} className="w-64" variant="outline">
                <span>Sign in with OIDC</span>
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Intentionally unlabeled, low-visibility entry point: admin-only API key sign in. */}
      <Dialog open={apiKeyDialogOpen} onOpenChange={setApiKeyDialogOpen}>
        <DialogTrigger asChild>
          <button
            aria-label="Admin API key sign in"
            className="fixed bottom-3 right-3 h-6 w-6 flex items-center justify-center rounded-full text-gray-300 opacity-40 hover:opacity-100 hover:text-gray-500 transition-opacity"
          >
            <KeyRound className="h-3.5 w-3.5" />
          </button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Sign in with API Key</DialogTitle>
            <DialogDescription>
              Enter your API key to authenticate. It will be used to authorize every API call instead of an OIDC session.
            </DialogDescription>
          </DialogHeader>
          <div className="flex flex-col gap-2">
            <Label htmlFor="api-key">API Key</Label>
            <Input
              id="api-key"
              type="password"
              autoComplete="off"
              value={apiKeyInput}
              onChange={(e) => setApiKeyInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleApiKeyLogin();
              }}
            />
          </div>
          <DialogFooter>
            <Button onClick={handleApiKeyLogin} disabled={!apiKeyInput.trim()}>
              Sign in
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  )
}
